export const GITBOOK_URL = "https://gt3.gitbook.io/gt3-english/gt3-english-1"
export const MEDIUM_URL = "https://gt3finance.medium.com/"
export const TELEGRAM_URL = "https://t.me/+slKX5OUVB6AwYTU0"
export const X_URL = "https://x.com/gt3finance"
